import type { VobWebformResult, VobWebformSubmitPayload } from './types';

const REQUIRED_FIELD_MESSAGES: Array<{
  key: keyof VobWebformSubmitPayload;
  message: string;
  validate: (form: VobWebformSubmitPayload) => boolean;
}> = [
  {
    key: 'first_name',
    message: 'First name is required',
    validate: (form) => Boolean(form.first_name?.trim()),
  },
  {
    key: 'last_name',
    message: 'Last name is required',
    validate: (form) => Boolean(form.last_name?.trim()),
  },
  {
    key: 'date_of_birth',
    message: 'Date of birth is required',
    validate: (form) => Boolean(form.date_of_birth?.trim()),
  },
  {
    key: 'phone',
    message: 'Phone is required',
    validate: (form) => Boolean(form.phone?.trim()),
  },
  {
    key: 'payor_id',
    message: 'Please select an insurance company',
    validate: (form) => {
      const payorId = Number(form.payor_id);
      return Boolean(payorId && !Number.isNaN(payorId));
    },
  },
  {
    key: 'member_id',
    message: 'Member ID is required',
    validate: (form) => Boolean(form.member_id?.trim()),
  },
];

export function validateRequiredFormFields(
  form: VobWebformSubmitPayload
): VobWebformResult | null {
  for (const rule of REQUIRED_FIELD_MESSAGES) {
    if (!rule.validate(form)) {
      return {
        success: false,
        validation: true,
        message: rule.message,
      };
    }
  }

  return null;
}
